import type { HasMessageFilterValue } from '../../../components/IncomingFeedback/ResponsesFilters/HasFeedbackMessageFilter/HasFeedbackMessageType';
import {
  HAS_MESSAGE_TYPE,
  isAllResponsesMessageFilterValue,
} from '../../../components/IncomingFeedback/ResponsesFilters/HasFeedbackMessageFilter/HasFeedbackMessageType';
import { IncomingFeedbackDtoFilters } from '../filters/FiltersMappings';
import type { FeedbackMessageFilterDto } from '../filters/FiltersMappings';

export function hasFeedbackMessageFilterConverter(
  filterValue: HasMessageFilterValue,
): FeedbackMessageFilterDto | undefined {
  if (!isAllResponsesMessageFilterValue(filterValue)) {
    return {
      type: IncomingFeedbackDtoFilters.FEEDBACK_MESSAGE,
      value: filterValue === HAS_MESSAGE_TYPE.YES,
    };
  }
}
